// Remove a node from DOM
export const removeNode = node => {
    if (node) {
        node.parentNode.removeChild(node);
    }
};

// Sort an array of object by a prop
export const sortArrayByProp = (array, prop) => array.sort((a, b) => (a[prop] > b[prop] ? 1 : -1));
